var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20 15.584v3.328C20 20.618 16.689 22 12.604 22s-7.396-1.382-7.396-3.088V17.35M2 11.329v3.33c0 1.705 3.311 3.087 7.396 3.087s7.396-1.382 7.396-3.087v-3.33M5.208 4.95v3.329c0 1.705 3.311 3.088 7.396 3.088S20 9.983 20 8.278V4.949M5.208 8.923C3.27 9.48 2 10.413 2 11.468c0 1.706 3.311 3.088 7.396 3.088s7.396-1.382 7.396-3.088c0-.136-.02-.27-.062-.4m-.495 1.963c2.247.53 3.765 1.537 3.765 2.691 0 1.705-3.311 3.088-7.396 3.088-2.318 0-4.387-.445-5.743-1.142-.156-.08-.229-.082-.365-.168m3.768-11.458-.29-1.093 4.758-.002-.303-1.095.606 2.19M20 5.088c0 1.705-3.311 3.087-7.396 3.087S5.208 6.793 5.208 5.088C5.208 3.382 8.519 2 12.604 2S20 3.382 20 5.088Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.d7622deddb4f2ec6fdcd3cfaa0cff705.svg";
export { ForwardRef as ReactComponent };